<template>
  <div class="root">
    <div class="top-wrapper">
      <h2 :class="$route.query.exhibitionType">
        {{ title }}
      </h2>
      <p class="time">
        展览时间：{{ time }}
      </p>
    </div>
    <img
      v-for="index of frameNumber"
      v-show="index - 1 === currentFrameIdx || index - 1 === currentFrameIdx - 1"
      :key="index"
      draggable="false"
      class="frame"
      :src="`${$publicPath}hand-rotate-frames/${$route.query.exhibitionId}/${index}.jpg`"
      alt=""
      @load="onImgLoad(index - 1)"
      @error="onImgError(index - 1)"
    >
    <van-loading
      v-show="isLoading"
      color="#1989fa"
      class="loading"
      type="spinner"
      size="3rem"
      vertical
    >
      <span style="font-size: 1rem;">
        {{ frameLoadProgress }}
      </span>
    </van-loading>
    <!-- <img
      class="background-image"
      src="@/assets/image/bg-text.png"
      alt="background"
    > -->
  </div>
</template>

<script>
import exhibitionData from '@/exhibitionData.js'

const frameNumber = 75

export default {
  data() {
    return {
      frameNumber,
      loadedNumber: 0,
      currentFrameIdx: 0,
      intervalId: null,
      imgStateList: new Array(frameNumber),
      loadCountDown: 40,
      isLoading: true,

      exhibitionData,
    }
  },
  computed: {
    choosenExhibition() {
      return this.exhibitionData[this.$route.query.exhibitionType][this.$route.query.exhibitionId]
    },
    title() {
      return this.choosenExhibition.title.split('<br>').join('')
    },
    time() {
      return this.choosenExhibition.time
    },
    frameLoadProgress() {
      return Math.floor(this.loadedNumber / frameNumber * 100) + '%'
    },
  },
  mounted() {
    this.intervalId = setInterval(() => {
      // 加载到一定程度再开始播放
      if (this.frameLoadProgress === '100%') {
        // if ((this.loadCountDown === 0) && (this.imgStateList[this.currentFrameIdx + 1] !== undefined)) {
        this.isLoading = false
        // 跳过加载失败的图片
        do {
          this.currentFrameIdx++
        } while (this.imgStateList[this.currentFrameIdx] === false)
        if (this.currentFrameIdx >= frameNumber - 1) {
          clearInterval(this.intervalId)
          this.$router.replace({ name: 'ExhibitionDetail', query: this.$route.query })
        }
      } else {
        this.isLoading = true
      }
    }, 41)
  },
  destroyed() {
    clearInterval(this.intervalId)
  },
  methods: {
    onImgLoad(idx) {
      if (idx < 40) {
        this.loadCountDown--
      }
      this.loadedNumber++
      console.log('success')
      this.imgStateList[idx] = true
    },
    onImgError(idx) {
      if (idx < 40) {
        this.loadCountDown--
      }
      this.loadedNumber++
      console.log('error')
      this.imgStateList[idx] = false
    }
  }
}
</script>

<style lang="less" scoped>
.root {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  > .top-wrapper {
    position: absolute;
    top: 2.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    line-height: 1.5;
    width: 13.66rem;
    > h2 {
      font-size: 0.94rem;
      font-family: Source Han Sans CN;
      font-weight: 800;
      line-height: 1.41rem;
      &.theme {
        color: #18489D;
      }
      &.wuyiba {
        color: #F15835;
      }
      &.traditionModern {
        color: #2FB779;
      }
    }
    > .time {
      margin: 0.3rem 0 0;
      font-size: 0.72rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #909090;
    }
  }
  > .frame {
    position: absolute;
    height: 100%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  > .loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  // > .background-image {
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   top: 0;
  //   object-fit: cover;
  //   width: 100%;
  //   height: 100%;
  // }
}
</style>
